export enum SportsFeatureFlags {
  GreyhoundRacingEnabled = 'ISP_GreyhoundRacingEnabled',
  HorseRacingEnabled = 'ISP_HorseRacingEnabled',
  ISPAmericanOdds = 'ISP_AmericanOdds',
  ISPAnimalRacingSpecials = 'ISP_Release_AnimalRacingSpecials',
  ISPBetBuilder = 'ISP_BetBuilder',
  ISPBetSlipCustomKeyboard = 'ISP_BetSlipCustomKeyboard',
  ISPBonusCash = 'ISP_BonusCash',
  ISPCashOut = 'ISP_CashOut',
  ISPDataVisualisation = 'ISP_DataVisualisation',
  ISPDynamicAlternates = 'ISP_DynamicAlternates',
  ISPEnableAddToBetSlipMyBets = 'ISP_Enable_AddToBetSlipMyBets',
  ISPEnableCorrectScoreTemplate = 'ISP_Enable_CorrectScoreTemplate',
  ISPEnableEnhancedBetTracking = 'ISP_Enable_EnhancedBetTracking',
  ISPEnableEventPagePopularBetBuilders = 'ISP_Enable_EventPagePopularBetBuilders',
  ISPEnableGlobalSportsSearch = 'ISP_Enable_GlobalSportsSearch',
  ISPEnableHomePagePopularAccumulators = 'ISP_Enable_HomePagePopularAccumulators',
  ISPEnableHomePagePopularBetBuilders = 'ISP_Enable_HomePagePopularBetBuilders',
  ISPEnableLandingPagePopularAccumulators = 'ISP_Enable_LandingPagePopularAccumulators',
  ISPEnableLandingPagePopularBetBuilders = 'ISP_Enable_LandingPagePopularBetBuilders',
  ISPEnableLiveAmericanFootballData = 'ISP_Enable_LiveAmericanFootballData',
  ISPEnableLiveBaseballData = 'ISP_Enable_LiveBaseballData',
  ISPEnableLiveBasketballData = 'ISP_Enable_LiveBasketballData',
  ISPEnableLiveDartsData = 'ISP_Enable_LiveDartsData',
  ISPEnableLiveData = 'ISP_Enable_LiveData',
  ISPEnableLiveESportsData = 'ISP_Enable_LiveESportsData',
  ISPEnableLiveFootballData = 'ISP_Enable_LiveFootballData',
  ISPEnableLiveHandballData = 'ISP_Enable_LiveHandballData',
  ISPEnableLiveIceHockeyData = 'ISP_Enable_LiveIceHockeyData',
  ISPEnableLiveStreaming = 'ISP_Enable_LiveStreaming',
  ISPEnableLiveTableTennisData = 'ISP_Enable_LiveTableTennisData',
  ISPEnableLiveTennisData = 'ISP_Enable_LiveTennisData',
  ISPEnableMarketMatchOddsNinety = 'ISP_Enable_MarketMatchOddsNinety',
  ISPEnableMarketMatchOddsTwoUp = 'ISP_Enable_MarketMatchOddsTwoUp',
  ISPEnableMaxStakeCTA = 'ISP_Enable_MaxStakeCTA',
  ISPEnableMobileStickyQuickLinks = 'ISP_Enable_MobileStickyQuickLinks',
  ISPEnableMyBetsDataVisualisation = 'ISP_Enable_MyBetsDataVisualisation',
  ISPEnableMyBetsLiveStreaming = 'ISP_Enable_MyBetsLiveStreaming',
  ISPEnablePopularSportsPicker = 'ISP_Enable_PopularSportsPicker',
  ISPEnablePromotionsQuickLink = 'ISP_Enable_PromotionsQuickLink',
  ISPEnableStarSub = 'ISP_Enable_StarSub',
  ISPExperimentPopularBetBuilderCount = 'ISP_Experiment_PopularBetBuilderCount',
  ISPHistoricalBets = 'ISP_HistoricalBets',
  ISPICEPromotions = 'ISP_ICE_Promotions',
  ISPMyStarsFreeBets = 'Visibility_MyStars_FreeBets',
  ISPPromotionPicker = 'ISP_PromotionPicker',
  ISPPromotions = 'ISP_Promotions',
  ISPQuickSwitcher = 'ISP_QuickSwitcher',
  ISPReleaseHomePageInPlayFeature = 'ISP_Release_HomePageInPlayFeature',
  ISPReleaseHomePageUpcomingEventsFeature = 'ISP_Release_HomePageUpcomingEventsFeature',
  ISPRouting = 'ISP_Routing',
  ISPScoreboards = 'ISP_Scoreboards',
  ISPSportsFreeBets = 'ISP_FreeBets',
  ISPStatusCheck = 'ISP_StatusCheck'
}
